// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__Q8CGp","containerImg":"EmptyList_containerImg__tv3PL","description":"EmptyList_description__ANZCT"};